<template>
    <form
        method="post"
        @submit.prevent="submit"
        @keydown="clearErrors($event.target.name)"
    >
        <div
            v-show="form.succeeded"
            id="result"
            class="alert alert-success"
        >
            {{ result }}
        </div>
        <input
            v-model="form.token"
            type="hidden"
            name="token"
        />
        <div
            class="form-group has-feedback"
            :class="{ 'has-error': form.errors.has('email') }"
        >
            <input
                v-model="form.email"
                type="email"
                class="form-control"
                :placeholder="trans('lang_message.email')"
                name="email"
                autofocus
            />
            <span class="glyphicon glyphicon-envelope form-control-feedback"></span>
            <transition name="fade">
                <span
                    v-if="form.errors.has('email')"
                    class="help-block"
                    v-text="form.errors.get('email')"
                ></span>
            </transition>
        </div>

        <div
            class="form-group has-feedback"
            :class="{ 'has-error': form.errors.has('password') }"
        >
            <input
                v-model="form.password"
                type="password"
                class="form-control"
                :placeholder="trans('lang_message.password')"
                name="password"
            />
            <span class="glyphicon glyphicon-lock form-control-feedback"></span>
            <transition name="fade">
                <span
                    v-if="form.errors.has('password')"
                    class="help-block"
                    v-text="form.errors.get('password')"
                ></span>
            </transition>
        </div>

        <div class="form-group has-feedback">
            <input
                v-model="form.password_confirmation"
                type="password"
                class="form-control"
                :placeholder="trans('lang_message.retypepassword')"
                name="password_confirmation"
            />
            <span class="glyphicon glyphicon-lock form-control-feedback"></span>
        </div>

        <div class="row">
            <div class="col-xs-2"></div>
            <!-- /.col -->
            <div class="col-xs-8">
                <button
                    type="submit"
                    class="btn btn-primary btn-block btn-flat"
                    :disabled="form.errors.any()"
                >
                    <i
                        v-if="form.submitting"
                        class="fa fa-refresh fa-spin"
                    ></i>
                    {{ trans('lang_message.passwordreset') }}
                </button>
            </div>
            <!-- /.col -->
            <div class="col-xs-2"></div>
            <!-- /.col -->
        </div>
    </form>
</template>

<script>
import Form from 'acacha-forms';
import redirect from './redirect';

export default {
    mixins: [redirect],
    props: {
        token: {
            type: String,
            required: true,
        },
    },
    data: function () {
        return {
            form: new Form({
                email: '',
                password: '',
                password_confirmation: '',
                token: this.token,
            }),
            result: '',
        };
    },
    methods: {
        submit() {
            this.form
                .post('/password/reset')
                .then((response) => {
                    this.result = response.data.status;
                    var component = this;
                    setTimeout(function () {
                        component.redirect(response);
                    }, 3000);
                })
                .catch((error) => {
                    console.log(this.trans('lang_message.passwordreset') + ':' + error);
                });
        },
        clearErrors(name) {
            if (name === 'password_confirmation') {
                name = 'password';
                this.form.errors.clear('password_confirmation');
            }
            this.form.errors.clear(name);
            this.form.succeeded = false;
            this.result = '';
        },
        mounted() {
            this.form.clearOnSubmit = true;
        },
    },
};
</script>

<style src="./fade.css"></style>
